// The height a Button occupies at each size, in pixels. MUI builds these from padding, border and
// line-height rather than exposing them as a value, so anything that has to stand level with a
// button in a toolbar — a toggle group, a slider — reads them from here instead of each guessing.
export const BUTTON_HEIGHT = { small: 30.75, medium: 36.5, large: 42.25 };
